import {
  AuthService,
  TenantSubDomainExtractorService
} from '@anecdotes/auth-core';
import { Injectable } from '@angular/core';
import { filter, firstValueFrom } from 'rxjs';
import { AppConfigService } from '@anecdotes/configuration-data-access';
import userflow from 'userflow.js'; // https://getuserflow.com/docs/dev/userflow-js-installation#step-1-choose-installation-method

@Injectable()
export class UserFlowInitializer {
  private initialized: boolean;
  private isEnabled: boolean;

  constructor(
    private configService: AppConfigService,
    private authService: AuthService,
    private tenantService: TenantSubDomainExtractorService,
  ) {}

  async identifyUserAsync(): Promise<void> {
    this.init();

    if (!this.isEnabled) {
      return;
    }

    const tenantSubdomain = this.tenantService.getCurrentTenantSubDomain();
    const user = await firstValueFrom(this.authService.getUser().pipe(filter((user) => !!user)));

    userflow.identify(user.email, {
      name: user.name,
      email: user.email,
      subdomain: tenantSubdomain,
      'User Role':  user.role?.split(':')[1], // removes anecdotes part (anecdotes:admin)
    });
  }

  async identifyAnonymousAsync(): Promise<void> {
    this.init();

    if (!this.isEnabled) {
      return;
    }

    const tenantSubdomain = this.tenantService.getCurrentTenantSubDomain();

    userflow.identifyAnonymous({
      subdomain: tenantSubdomain,
    });
  }

  private init(): void {
    if (!this.initialized) {
      const token = this.configService.config.userflow?.token;
      this.isEnabled = !!token;

      if (this.isEnabled) {
        userflow.init(token);
      }

      this.initialized = true;
    }
  }
}
